export const SEARCH_DELAY = 500;
export const DEFAULT_PAGE_SIZE = 10;

